import { type EpgInfo } from '@setplex/tria-api'
import { createEvent, createStore, sample } from 'effector'
import { nay } from '~/shared/helpers'
import { getMapKeyForProgram } from '../lib/upcoming'
import { fetchProgramEpg, fetchProgramEpgFx } from './fetch'

// upcoming programs by epg info key (key is calculated using function `forProgram`)
export const $upcoming = createStore<[Map<string, EpgInfo[] | null>]>([
  new Map(),
])

// request fetch epg data request from widget
export const fetchUpcoming = createEvent<EpgInfo>()

// trigger fetch epg data effect only if there is no upcoming data for given program
sample({
  clock: fetchUpcoming,
  source: $upcoming,
  filter: ([programs], program) =>
    nay(programs.has(getMapKeyForProgram(program))),
  fn: (_, program) => program,
  target: fetchProgramEpg,
})

// update upcoming data from epg response
sample({
  clock: fetchProgramEpgFx.done,
  source: $upcoming,
  fn: ([programs], { params, result: info }) => {
    const key = getMapKeyForProgram({
      epgId: params.epgId,
      title: params.programTitle,
      startMs: params.start,
    })
    const upcoming = info == null ? [] : info
    programs.set(key, upcoming)
    return [programs] as const
  },
  target: $upcoming,
})
